import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { useHandleNetworkError } from "utils/useHandleNetworkError";

export const useClaimTask = (onSuccess) => {
  const queryClient = useQueryClient();

  const handleNetworkError = useHandleNetworkError("Error while claiming task");

  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useMutation({
    mutationFn: async (taskId) => {
      const axiosInstance = await createAxiosInstance();
      const response = await axiosInstance.post(`${tenantVal}/task/${taskId}/claim`, {
        id: taskId,
        tenant: tenantVal,
      });
      return response.data;
    },
    onSuccess: () => {
      toast.success("Task claimed successfully");
      queryClient.invalidateQueries({ queryKey: ["tasks"] });
      queryClient.invalidateQueries({ queryKey: ["task"] });
      queryClient.invalidateQueries({ queryKey: ["homeTasks"] });
      queryClient.invalidateQueries({ queryKey: ["closedPaginatedTasks"] });
      queryClient.invalidateQueries({ queryKey: ["paginatedTasks"] });
      queryClient.invalidateQueries({ queryKey: ["sentPaginatedTasks"] });
      queryClient.invalidateQueries({ queryKey: ["prescriptionTasks"] });
      queryClient.invalidateQueries({ queryKey: ["patientTasks"] });
      onSuccess?.();
    },
    onError: handleNetworkError,
  });
};
